// Club Penguin Game Initialization
import { ClubPenguinGame } from './components/ClubPenguinGame.js';

declare global {
  interface Window {
    toggleMusic?: () => void;
    toggleRain?: () => void;
    game: ClubPenguinGame;
    debugGame: {
      teleport: (x: number, y: number) => void;
      gotoRoom: (roomId: string, x?: number, y?: number) => void;
      listRooms: () => void;
    };
  }
}

// Initialize game when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  window.game = new ClubPenguinGame();
});

// Debug helpers
window.debugGame = {
  teleport: (x: number, y: number) => {
    if (window.game) {
      window.game.teleport(x, y);
    }
  },

  gotoRoom: (roomId: string, x?: number, y?: number) => {
    if (window.game) {
      window.game.gotoRoom(roomId, x, y);
    }
  },

  listRooms: () => {
    if (window.game) {
      return window.game.listRooms();
    }
    return [];
  },
};
